import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Check } from "lucide-react";

function Pedestrian({ x, y, color }) {
  return (
    <g transform={`translate(${x},${y})`}>
      <circle cx={0} cy={-10} r={3} fill={color} />
      <rect x={-2.5} y={-7} width={5} height={9} rx={1.5} fill={color} />
      <rect x={-2.5} y={2} width={2} height={5} fill={color} />
      <rect x={0.5} y={2} width={2} height={5} fill={color} />
    </g>
  );
}

function ShopsScene() {
  const shops = [55, 245];
  return (
    <div
      className="w-full h-[130px]"
      style={{ background: "linear-gradient(to bottom, #FEF3E7 0%, #FEF3E7 85.3%, #F4D9B8 85.3%, #F4D9B8 100%)" }}
    >
      <svg viewBox="0 0 300 150" preserveAspectRatio="xMidYMid meet" aria-hidden="true" className="w-full h-full">
        <rect x="0" y="0" width="300" height="150" fill="#FEF3E7" />
        <rect x="0" y="128" width="300" height="22" fill="#F4D9B8" />

      {shops.map((x, i) => (
        <g key={x}>
          <rect x={x - 38} y={70} width={76} height={50} rx={4} fill="#FDE8D8" stroke="#F2B486" strokeWidth={1.5} />
          <path d={`M ${x - 42} 70 L ${x - 30} 52 L ${x + 30} 52 L ${x + 42} 70 Z`} fill={i === 0 ? "#F97362" : "#4E9BEE"} />
          <rect x={x - 9} y={92} width={18} height={28} rx={2} fill="#8B5E3C" />
          <rect x={x - 28} y={80} width={14} height={14} rx={2} fill="#BFE3FB" />
          <rect x={x + 14} y={80} width={14} height={14} rx={2} fill="#BFE3FB" />
          <motion.g
            style={{ transformOrigin: `${x}px 48px` }}
            animate={{ rotate: [-4, 4, -4] }}
            transition={{ duration: 2.6, repeat: Infinity, ease: "easeInOut", delay: i * 0.4 }}
          >
            <rect x={x - 12} y={40} width={24} height={14} rx={3} fill="#1E293B" />
            <text x={x} y={50} textAnchor="middle" fontSize="9" fill="#fff" fontWeight="700">₽</text>
          </motion.g>
        </g>
      ))}

      {/* cafe in the middle, with a terrace and tables */}
      <g>
        <rect x={112} y={70} width={76} height={50} rx={4} fill="#FBEFD9" stroke="#E7B977" strokeWidth={1.5} />
        <path d="M 108 70 L 120 52 L 180 52 L 192 70 Z" fill="#C97B3F" />
        <rect x={141} y={92} width={18} height={28} rx={2} fill="#8B5E3C" />
        <rect x={121} y={80} width={14} height={14} rx={2} fill="#BFE3FB" />
        <rect x={165} y={80} width={14} height={14} rx={2} fill="#BFE3FB" />
        <motion.g
          style={{ transformOrigin: "150px 48px" }}
          animate={{ rotate: [-3, 3, -3] }}
          transition={{ duration: 2.8, repeat: Infinity, ease: "easeInOut" }}
        >
          <rect x={138} y={40} width={24} height={14} rx={3} fill="#5C3A21" />
          <path d="M 146 44 h8 v4 a4 4 0 0 1 -8 0 Z" fill="#fff" />
        </motion.g>

        {/* terrace */}
        <rect x={100} y={120} width={100} height={22} rx={3} fill="#D8B384" stroke="#BE9566" strokeWidth={1} />
        <circle cx={122} cy={127} r={9} fill="#fff" stroke="#CBB183" strokeWidth={1.5} />
        <ellipse cx={111} cy={133} rx={4} ry={6} fill="#A9742F" />
        <ellipse cx={133} cy={133} rx={4} ry={6} fill="#A9742F" />
        <rect x={119} y={122} width={6} height={4} rx={1} fill="#5C3A21" />
        {[0, 1].map((s) => (
          <motion.path
            key={s}
            d={`M ${120 + s * 4} 120 q 2 -4 0 -8`}
            stroke="#CBD5E1"
            strokeWidth={1.2}
            fill="none"
            strokeLinecap="round"
            initial={{ opacity: 0 }}
            animate={{ opacity: [0, 0.8, 0], y: [0, -6] }}
            transition={{ duration: 2.2, repeat: Infinity, delay: s * 0.6, ease: "easeOut" }}
          />
        ))}
        <circle cx={178} cy={127} r={9} fill="#fff" stroke="#CBB183" strokeWidth={1.5} />
        <ellipse cx={167} cy={133} rx={4} ry={6} fill="#A9742F" />
        <ellipse cx={189} cy={133} rx={4} ry={6} fill="#A9742F" />
      </g>

      {/* someone walks up and steps inside the cafe */}
      <motion.g
        animate={{ x: [-30, 0, 0], opacity: [1, 1, 0], scale: [1, 1, 0.6] }}
        transition={{ duration: 4, repeat: Infinity, times: [0, 0.7, 1], ease: "easeInOut" }}
      >
        <Pedestrian x={150} y={112} color="#334155" />
      </motion.g>

      {/* someone steps out of the cafe and walks off */}
      <motion.g
        animate={{ x: [0, 0, 40, 46], opacity: [0, 1, 1, 0] }}
        transition={{ duration: 4.4, repeat: Infinity, delay: 2, times: [0, 0.15, 0.8, 1], ease: "easeInOut" }}
      >
        <Pedestrian x={150} y={112} color="#475569" />
      </motion.g>

      {/* passers-by on the street */}
      <motion.g animate={{ x: [-90, 390] }} transition={{ duration: 10, repeat: Infinity, ease: "linear" }}>
        <Pedestrian x={0} y={142} color="#64748B" />
      </motion.g>
      <motion.g animate={{ x: [390, -90] }} transition={{ duration: 12, repeat: Infinity, ease: "linear", delay: 1.5 }}>
        <Pedestrian x={0} y={137} color="#94A3B8" />
      </motion.g>
      </svg>
    </div>
  );
}

function FarmScene() {
  return (
    <div
      className="w-full h-[130px]"
      style={{ background: "linear-gradient(to bottom, #EAF6FF 0%, #EAF6FF 63.3%, #8BC34A 63.3%, #8BC34A 100%)" }}
    >
      <svg viewBox="0 0 300 150" preserveAspectRatio="xMidYMid meet" aria-hidden="true" className="w-full h-full">
        <rect x="0" y="0" width="300" height="95" fill="#EAF6FF" />
        <circle cx="255" cy="30" r="18" fill="#FDE68A" />
        <motion.g animate={{ x: [0, 20, 0] }} transition={{ duration: 8, repeat: Infinity, ease: "easeInOut" }}>
          <ellipse cx="60" cy="28" rx="22" ry="8" fill="#fff" />
          <ellipse cx="80" cy="24" rx="16" ry="7" fill="#fff" />
        </motion.g>
        <rect x="0" y="95" width="300" height="55" fill="#8BC34A" />
        {[...Array(6)].map((_, i) => (
          <rect key={i} x={i * 52} y={95} width={26} height={55} fill="#7CB342" opacity={0.5} />
        ))}
        <motion.g animate={{ x: [-90, 390] }} transition={{ duration: 7, repeat: Infinity, ease: "linear" }}>
          <rect x="0" y="100" width="46" height="22" rx="4" fill="#F59E0B" />
          <rect x="34" y="84" width="22" height="20" rx="3" fill="#1E293B" />
          <rect x="38" y="88" width="14" height="10" rx="1" fill="#BFE3FB" />
          <motion.g style={{ transformOrigin: "10px 128px" }} animate={{ rotate: 360 }} transition={{ duration: 0.8, repeat: Infinity, ease: "linear" }}>
            <circle cx="10" cy="128" r="9" fill="#1E293B" />
            <rect x="9" y="120" width="2" height="16" fill="#94A3B8" />
          </motion.g>
          <motion.g style={{ transformOrigin: "40px 128px" }} animate={{ rotate: 360 }} transition={{ duration: 0.8, repeat: Infinity, ease: "linear" }}>
            <circle cx="40" cy="128" r="12" fill="#1E293B" />
            <rect x="39" y="117" width="2" height="22" fill="#94A3B8" />
          </motion.g>
        </motion.g>
      </svg>
    </div>
  );
}

function FactoryScene() {
  const puffs = [
    { cx: 69, cy: 26 },
    { cx: 119, cy: 16 },
  ];
  return (
    <div
      className="w-full h-[130px]"
      style={{ background: "linear-gradient(to bottom, #EEF2F6 0%, #EEF2F6 86.7%, #E2E8F0 86.7%, #E2E8F0 100%)" }}
    >
      <svg viewBox="0 0 300 150" preserveAspectRatio="xMidYMid meet" aria-hidden="true" className="w-full h-full">
        <rect x="0" y="0" width="300" height="150" fill="#EEF2F6" />
        <rect x="0" y="130" width="300" height="20" fill="#E2E8F0" />
        <rect x="40" y="70" width="140" height="60" fill="#64748B" />
        <rect x="60" y="30" width="18" height="40" fill="#475569" />
        <rect x="110" y="20" width="18" height="50" fill="#475569" />
        {puffs.map((p, ci) =>
          [0, 1, 2].map((pi) => (
            <motion.circle
              key={`${ci}-${pi}`}
              cx={p.cx}
              cy={p.cy}
              r={8}
              fill="#CBD5E1"
              initial={{ opacity: 0, scale: 0.6 }}
              animate={{ opacity: [0, 0.6, 0], y: [0, -30], scale: [0.6, 1.4] }}
              transition={{ duration: 3, repeat: Infinity, delay: pi * 1 + ci * 0.5, ease: "easeOut" }}
            />
          ))
        )}
        {[...Array(5)].map((_, i) => (
          <rect key={i} x={55 + i * 25} y={88} width={14} height={14} fill="#FDE68A" opacity={0.85} />
        ))}
        <g transform="translate(220,90)">
          <rect x="-24" y="0" width="4" height="34" fill="#334155" />
          <rect x="14" y="0" width="4" height="34" fill="#334155" />
          <motion.g style={{ transformOrigin: "0px 0px" }} animate={{ rotate: [-8, 8, -8] }} transition={{ duration: 2.2, repeat: Infinity, ease: "easeInOut" }}>
            <rect x="-30" y="-4" width="60" height="8" rx="3" fill="#0F172A" />
            <circle cx="-30" cy="0" r="5" fill="#0F172A" />
          </motion.g>
          <rect x="-3" y="30" width="6" height="18" fill="#0F172A" />
        </g>
      </svg>
    </div>
  );
}

const TIERS = [
  {
    id: "small",
    testid: "landing-pricing-card-small",
    badge: "Малый бизнес",
    price: "1,99",
    audience: "ИП, небольшие магазины и мастерские",
    features: ["Безлимит документов в месяц", "1 организация", "Поддержка в чате"],
    Scene: ShopsScene,
  },
  {
    id: "medium",
    testid: "landing-pricing-card-medium",
    badge: "Средний бизнес",
    price: "1,70",
    accent: true,
    audience: "Сельхозпредприятия, дистрибьюторы, розничные сети",
    features: ["Групповые согласования", "Распределение документов по сотрудникам", "Приоритетная поддержка"],
    Scene: FarmScene,
  },
  {
    id: "large",
    testid: "landing-pricing-card-large",
    badge: "Крупный бизнес",
    price: "1,65",
    audience: "Промышленные холдинги и нефтегазовые компании",
    features: ["Интеграция с 1С и внешнее API", "Безлимит пользователей", "Персональный менеджер"],
    Scene: FactoryScene,
  },
];

export function LandingPricing() {
  return (
    <section id="pricing" className="py-20 md:py-28 bg-white" data-testid="landing-pricing-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-4">
          <div className="text-xs uppercase tracking-[0.2em] font-semibold text-[#2563EB] mb-3">Тарифы</div>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-slate-900">
            Честная цена для любого масштаба бизнеса
          </h2>
          <p className="mt-3 text-sm sm:text-base text-slate-600 max-w-xl mx-auto">
            Оплата только за фактически отправленные документы — без абонентской платы.
            Сначала попробуйте бесплатно в{" "}
            <a href="#how-it-works" className="text-[#2563EB] font-medium hover:underline">живом демо-кабинете выше</a>.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mt-12">
          {TIERS.map((t) => (
            <div
              key={t.id}
              data-testid={t.testid}
              className={`rounded-2xl border overflow-hidden flex flex-col transition-transform hover:-translate-y-1 ${
                t.accent ? "border-[#4E9BEE]/40 shadow-[0_20px_50px_-15px_rgba(78,155,238,0.35)] md:scale-[1.04]" : "border-slate-200 shadow-sm"
              }`}
            >
              <t.Scene />
              <div className="p-6 flex flex-col flex-1">
                {t.accent && (
                  <span className="self-start mb-2 text-[10px] font-bold uppercase tracking-wider text-white bg-gradient-to-r from-[#4E9BEE] to-[#2563EB] px-2.5 py-1 rounded-full">
                    Популярный выбор
                  </span>
                )}
                <div className="text-sm font-semibold text-slate-500 mb-1">{t.badge}</div>
                <div className="flex items-baseline gap-1.5 mb-1">
                  <span className="text-3xl sm:text-4xl font-extrabold text-slate-900">{t.price} ₽</span>
                  <span className="text-xs text-slate-400">/ документ</span>
                </div>
                <p className="text-xs sm:text-sm text-slate-500 mb-5">{t.audience}</p>
                <ul className="space-y-2.5 mb-6 flex-1">
                  {t.features.map((f) => (
                    <li key={f} className="flex items-start gap-2 text-sm text-slate-700">
                      <Check className="w-4 h-4 text-[#10B981] mt-0.5 shrink-0" />
                      {f}
                    </li>
                  ))}
                </ul>
                <Link
                  to="/register"
                  data-testid={`${t.testid}-cta`}
                  className={`text-center text-sm font-semibold rounded-xl py-3 transition-colors ${
                    t.accent
                      ? "text-white bg-gradient-to-r from-[#4E9BEE] to-[#2563EB] hover:scale-[1.02]"
                      : "text-slate-700 border border-slate-200 hover:border-[#4E9BEE]/50 hover:text-slate-900"
                  }`}
                >
                  Подключить тариф
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
